import { render, staticRenderFns } from "./TilesSelection.vue?vue&type=template&id=5b552704"
import script from "./TilesSelection.vue?vue&type=script&lang=ts"
export * from "./TilesSelection.vue?vue&type=script&lang=ts"
import style0 from "./TilesSelection.vue?vue&type=style&index=0&id=5b552704&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports